module.exports = __webpack_public_path__ + "media/images/icon__point--text-d6713629c2bb0358e863d71a52315068.png";